import _ from 'lodash';
import React, {Component, Fragment} from 'react';
import styles from './DiscussionSection.module.scss';
import classNames from 'classnames';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses} from '../gameHelpers';
import {isLastRound} from '../gameHelpers';
import Button from '../Button';
import roundRegistry from '../roundRegistry';

const Section = posed.div({});

const Container = posed.div({
    visible: {
        y: 0,
        transition: {
            ease: 'easeOut',
            delay: 1000,
            duration: 1000,
        },
        delayChildren: 1000,
    },
    hidden: {
        y: '100%',
        transition: {
            ease: 'easeOut',
            delay: 0,
            duration: 1000,
        },
    },
});

const Clues = posed.div({
    visible: {
        y: 0,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    },
    hidden: {
        y: '100%',
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    },
});

export default function DiscussionSection({game, onNext, onPrevious, onClose}) {
    const label = isLastRound(game) ? 'Done' : 'Next';
    const {message, influence} = roundRegistry[game.round];

    const containerTallClassName = classNames(styles.container, styles.containerTall);
    const containerShortClassName = classNames(styles.container, styles.containerShort);

    return (
        <Section className={styles.section}>
            <Container
                className={containerShortClassName}
                pose={visibleOnStep(game, 0)}
                initialPose='hidden'
            >
                <Clues className={styles.clues}>
                    <div className={styles.lamp} />
                    <div className={styles.cluesText}>Clues: Lyrics, Themes, Tones </div>
                </Clues>

                <div className={styles.cluesCurtain} />

                <div className={styles.paper}>
                    <div className={styles.headerBlock}>
                        <div className={styles.header}>Discussion</div>
                        <div className={styles.header}>Section</div>
                        <div className={styles.line} />
                    </div>

                    <div className={styles.discussionDescription}>
                        <div className={styles.descriptionLine}>
                            Both teams think and respond to the following questions:
                        </div>

                        <div className={styles.descriptionLine}>
                            <div className={styles.spacer} />
                            1) What message is the artist sending about relationships?
                        </div>

                        <div className={styles.descriptionLine}>
                            <div className={styles.spacer} />
                            2) What kind of influence do you think this message is having
                            among teens?
                        </div>
                    </div>

                    <Button label='Next' onClick={onNext} />
                </div>
            </Container>

            <Container className={containerTallClassName} pose={visibleOnStep(game, 1)}>
                <div className={styles.paper}>
                    <div className={styles.content}>
                        <BackButton text='Discussion Section' onBack={onPrevious} />

                        <div className={styles.headerBlock}>
                            <div className={styles.header}>Message</div>
                            <div className={styles.line} />
                        </div>

                        <div className={styles.messageDescription}>{message}</div>
                    </div>

                    <Button label='Next' onClick={onNext} />
                </div>
            </Container>

            <Container className={containerTallClassName} pose={visibleOnStep(game, 2)}>
                <div className={styles.paper}>
                    <div className={styles.content}>
                        <BackButton text='Message' onBack={onPrevious} />

                        <div className={styles.headerBlock}>
                            <div className={styles.header}>So, what’s the takeaway?</div>
                            <div className={styles.line} />
                        </div>

                        <div className={styles.messageDescription}>{influence}</div>
                    </div>

                    <Button label='Next' onClick={onNext} />
                </div>
            </Container>

            <Container className={containerShortClassName} pose={visibleOnStep(game, 3)}>
                <div className={styles.paper}>
                    <BackButton
                        text='Takeaway'
                        className={styles.lastBackButton}
                        onBack={onPrevious}
                    />

                    <div className={styles.thinkContent}>
                        <div className={styles.headerBlock}>
                            <div className={styles.header}>What do you think?</div>
                            <div className={styles.line} />
                        </div>

                        <div className={styles.thinkBlock}>
                            <div>Do you agree with the interpretation?</div>
                            <div>Do you have a point of view to share?</div>
                        </div>
                    </div>

                    <Button label={label} onClick={onClose} />
                </div>
            </Container>
        </Section>
    );
}

function BackButton({text, className, onBack}) {
    const buttonClassName = classNames(styles.backButton, className);

    return (
        <div className={buttonClassName} onClick={onBack}>
            <div className={styles.backSign} />
            <div className={styles.backText}>{text}</div>
        </div>
    );
}

function visibleOnStep(game, step) {
    return game.discussionStep === step ? 'visible' : 'hidden';
}
